/**
 * SuperAdmin Tenant detail — /superadmin/tenants/$id (route shell).
 *
 * Screen impl in `./$id-screen.tsx`, lazy-loaded. Platform-operator-only surface
 * (behind the /superadmin layout gate) — never on a trustee's path. This is the
 * heaviest screen in the admin tree (six destructive-action modals), so lazy-
 * loading it is the single biggest route-split win.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/tenants/$id')({
  component: lazyRouteComponent(() => import('./$id-screen'), 'TenantDetailScreen'),
});
